import { Injectable } from '@angular/core';
import {
  HttpHandler,
  HttpRequest,
  HttpInterceptor,
} from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { LoadingService } from '@shared/loading';
import { Router } from '@angular/router';
import { ToastService } from 'src/app/shared/events/toast.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private _loading: LoadingService,
    private toastService: ToastService,
    private _router: Router
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req).pipe(
      catchError((error) => {
        this._loading.isLoading = false;

        if (error.status === 0 || error.status >= 500) {
          this.toastService.toastError(
            'No hemos logrado comunicarnos con nuestros servidores.'
          );
        }

        throw error;
      })
    );
  }
}
